import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Routes } from 'src/Routes.constants';

type LoadingProps = {
  accountId?: null;
  loading: true;
};

type LoadedProps = {
  accountId: string;
  loading: false;
};

type LocationDetailsFleetButtonProps = LoadingProps | LoadedProps;

const buttonSx = (theme: Theme): { width: string; marginTop: string; marginBottom: string } => ({
  width: '100%',
  marginTop: theme.spacing(12),
  marginBottom: theme.spacing(6),
});

export const LocationDetailsFleetButton: FC<LocationDetailsFleetButtonProps> = (props) => {
  const { accountId, loading } = props;
  const { t } = useTranslation();

  if (loading) {
    return <Button sx={buttonSx} loading={loading} />;
  }

  return (
    <Button
      sx={buttonSx}
      component={Link}
      to={{ pathname: Routes.locations, search: `?account=${accountId}` }}
      color="secondary"
    >
      {t('locations.details.viewFleet')}
    </Button>
  );
};
